import colors from '@rategravity/frontend/theme/colors';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import React from 'react';

export default (path) => () => (
  <Dialog
    contentStyle={{ maxWidth: 600, margin: 'auto' }}
    open
    title="There is a problem with your internet connection."
    modal
    actions={[
      <FlatButton
        key="reload-btn"
        label="Reload questionnaire"
        primary
        onClick={() => window.location.replace(`/${path}`)}
      />
    ]}
  >
    <span style={{ color: colors.primary }}>
      Don&apos;t worry! We have saved the information you entered so far. Once your connection is
      restored, please reload the questionnaire.
    </span>
  </Dialog>
);



// WEBPACK FOOTER //
// ./src/components/modal/timeout.js